export default __webpack_public_path__ + "static/media/AutoVD4.d6c6bd89.png";